import { Button, Card, Descriptions, Flex, Space, Spin, Form } from "antd";
import React, { Component } from "react";
import withRouter from "hocs/withRouter";
import NavigationService from "services/navigation";
import api from "services/api";
import { Field, Form as FinalForm } from "react-final-form";
import FormGroup from "components/form/formGroup";

class ReportPage extends Component {
  constructor(props) {
    super(props);

    this.reportId = this.props.params.reportId;
    this.state = {
      loading: true,
      report: null,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await api.getReport(this.reportId);
      console.log(" data", data);
      this.setState({
        loading: false,
        report: data,
      });
    } catch (err) {
      this.goBack();
      console.log("err", err);
    }
  }

  goBack = () => {
    NavigationService.navigate(-1);
  };

  submitReport = async (values) => {
    try {
      await api.updateReport(this.reportId, { ...values, status: "submited" });
      this.goBack();
    } catch (err) {
      console.log("err", err);
    }
  };

  render() {
    const { loading, report } = this.state;
    if (loading) return <Spin fullscreen />;

    return (
      <Flex style={{ flex: 1 }} vertical>
        <Card title={report.workSessionPeriod}>
          <Space direction="vertical">
            <Descriptions bordered layout="horizontal">
              {report.data.map((item, index) => (
                <Descriptions.Item
                  key={index}
                  label={item.label}
                  contentStyle={{ flex: 1, justifyContent: "flex-end" }}
                >
                  {item.value}
                </Descriptions.Item>
              ))}
            </Descriptions>
            {report.status === "pending" && (
              <FinalForm onSubmit={this.submitReport} style={{ marginTop: 10 }}>
                {({ handleSubmit }) => (
                  <Form layout="vertical">
                    <Field
                      component={FormGroup}
                      type="textarea"
                      name="comment"
                      minRows={10}
                      inputStyle={{ width: "100%" }}
                      label="Comment"
                    />
                    <Button type="primary" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </Form>
                )}
              </FinalForm>
            )}
          </Space>
        </Card>
      </Flex>
    );
  }
}

export default withRouter(ReportPage);
